function reverseCountdown(reverseCountdownItem, endNumber) {
    const intervalTime = 16; // Update interval in milliseconds
    const totalRuntime = 1000; // Total runtime in milliseconds
    const steps = Math.ceil(totalRuntime / intervalTime);

    // Detect decimals (max 2 places)
    const decimalPlaces = (endNumber.toString().split(".")[1] || "").length;
    const multiplier = decimalPlaces === 1 ? 10 : decimalPlaces === 2 ? 100 : 1;

    const adjustedEnd = Math.round(endNumber * multiplier);

    const stepSize = Math.max(1, adjustedEnd / steps); // Ensure at least 1 step
    let currentNumber = 0;

    const interval = setInterval(() => {
        if (currentNumber < adjustedEnd) {
            currentNumber += stepSize;
            currentNumber = Math.round(currentNumber);

            if (currentNumber >= adjustedEnd) {
                currentNumber = adjustedEnd;
                clearInterval(interval);
            }

            // Convert back to correct decimal format
            let displayNumber = currentNumber / multiplier;

            // Format with commas & decimals
            const formattedNumber = displayNumber.toLocaleString(undefined, {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces
            });

            reverseCountdownItem.innerHTML = formattedNumber;
        } else {
            clearInterval(interval);
        }
    }, intervalTime);

    // Ensure final value is set correctly
    reverseCountdownItem.innerHTML = endNumber.toLocaleString(undefined, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    });
}

function startReverseCountdownWhenFullyVisible(reverseCountdownItem) {
    const endNumber = parseFloat(reverseCountdownItem.dataset.countdownReverse);

    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && entries[0].intersectionRatio === 1) {
            setTimeout(() => {
                reverseCountdown(reverseCountdownItem, endNumber);
            }, 150);
            observer.unobserve(reverseCountdownItem);
        }
    }, { threshold: 1 });

    observer.observe(reverseCountdownItem);
}

window.addEventListener('load', () => {
    const reverseCountdownItems = document.querySelectorAll("[data-countdown-reverse]");

    for (let reverseCountdownItem of reverseCountdownItems) {
        startReverseCountdownWhenFullyVisible(reverseCountdownItem);
    }
});
